import Vue from 'vue'
import Vuex from 'vuex'
import * as axios from 'axios';
import * as jwt from "jsonwebtoken";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        user: {
            id: undefined,
            role: undefined,
            firstname: undefined,
            lastname: undefined,
            email: undefined
        },
        users: [],
        token: undefined,
        company: {
            id: undefined,
            name: undefined,
            registrationNumber: undefined,
            contactPerson: {
                id: undefined,
                firstname: undefined,
                lastname: undefined
            }
        },
        companies: [],
        snackbar: {
            show: false,
            text: "",
            color: "success",
            top: false,
            bottom: true,
            right: true,
            timeout: 2500
        },
        application: {
            name: "",
            purposes: [],
            areas: [],
            ageGroup: "",
            expenses: {
                procurements: [],
                inhouse: []
            },
            multiyear: false,
            yearCount: 0,
            yearlySplit: []
        }
    },
    getters: {
        user: state => {
            return state.user;
        },
        users: state => { return state.users; },
        company: state => {
            return state.company;
        },
        companies: state => {
            return state.companies.sort((a,b) => {
                if(a.name > b.name) return 1;
                else if(a.name < b.name) return -1;
                else return 0;
            });
        },
        isLoggedIn: state => {
            return state.user.id > 0;
        },
        token: state => {
            return state.token;
        },
        snackbar: state => {
            return state.snackbar;
        }
    },
    // Mutations must be synchronous - commit
    mutations: {
        user(state, user) {
            if (user && user.id && user.email) {
                localStorage.setItem("email", user.email);
            }

            state.user = user;
        },
        users(state, users) {
            state.users = users;
        },
        company(state, company) {
            state.company = company;
            if (company) {
                axios.defaults.params = { companyId: company.id };
                localStorage.setItem("company", JSON.stringify(company));
            }
            else {
                delete axios.defaults.params.companyId;
                // axios.defaults.params = {}
            }
        },
        token(state, token) {
            state.token = token;
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        },
        companies(state, companies) {
            state.companies = companies;
        },
        snackbar(state, snackbar) {
            if (state.snackbar.show) {
                state.snackbar.show = false;
            }

            if ("text" in snackbar) {
                state.snackbar.text = snackbar.text;
            }
            if ("color" in snackbar) {
                state.snackbar.color = snackbar.color;
            }

            state.snackbar.show = true;
        }
    },
    // Actions are asynchronous - dispatch?
    actions: {
        // LOGIN AND AUTHENTICATION
        async login(context, { email, password }) {
            let response = await axios.post("/authenticate/login", {
                email,
                password
            });

            let token = response.data;
            context.commit("token", token);

            let decodedToken = jwt.decode(token);
            context.commit("user", decodedToken.user);
        },
        async updateToken(context, companyId) {
            let response = await axios.post("/authenticate/updatetoken", { companyId })
            let token = response.data;
            context.commit("token", token);

            let decodedToken = jwt.decode(token);
            let user = context.getters.user;
            user.role = decodedToken.role;
            context.commit("user", user);

            await context.dispatch("fetchUsersForCurrentCompany");
        },
        logout(context) {
            context.commit("companies", []);
            context.commit("company", undefined); // TODO maybe keep this for convenience at relogin?
            context.commit("token", undefined);
            context.commit("user", { id: 0 });
        },

        // APPLICATION
        async createApplication(context, application) {
            // try {
            let response = await axios.post(`/application`, { application });
            return response.data;
            // } catch (error) {
            //     throw error;
            // }
        },
        async updateApplication(context, application) {
            // try {
            let response = await axios.put(`/application/updateApplication`,
                { application });
            return response.data;
            // } catch (error) {
            //     throw error;
            // }
        },
        async getEmptyApplication() {
            // try {
            let response = await axios.get(`/application/new`);
            return response.data;
            // } catch (error) {
            //     throw error;
            // }
        },
        async getApplication(context, { applicationId, include } = { applicationId, include: null }) {
            // try {
            if (!include) {
                // include = "[createdBy,updatedBy,ownedBy,applicationChoices,procurements,procurementSplits,fundings,reports.[contents,createdBy],payments]";
                include = "[applicationChoices,procurements,procurementSplits,fundings,reports.[contents,createdBy],payments,statuses,createdBy,updatedBy,ownedBy]";
            }

            let response = await axios.get(`/application/${applicationId}`, {
                params: {
                    include: include
                }
            });

            return response.data;
            // } catch (error) {
            //     throw error;
            // }

        },
        async getApplicationsByCompany(context, { include, companyId }) {
            // try {
            if (!include) {
                include = "[createdBy,updatedBy,applicationChoices,statuses]";
            }
            let url = companyId ? `/application/company/${companyId}` : "/application/company"
            let response = await axios.get(url, { params: { include } });
            return response.data.sort(
                (a, b) => a.createdAt - b.createdAt
            );
            // } catch (error) {
            //     throw error;
            // }
        },
        async updateApplicationStatus(context, { status, applicationId, reason } = { status, applicationId, reason: "" }) {
            // { include } = { include: ""}
            // try {
            let response = await axios.post(`/status/application/${applicationId}`, { status, reason });
            return response.data;
            // } catch (error) {
            //     throw error;
            // }

        },

        // USER
        async registerUser(context, { user, password, registrationNumber }) {
            // try {
            let response = await axios.post("/authenticate/registeruser", {
                user,
                password,
                registrationNumber
            });
            return response.data;
            // } catch (error) {
            //     throw error;
            // }
        },
        async approveUser(context, { companyId, userId }) {
            // try {
            await axios.post(`/company/approveuser`, {
                companyId,
                userId,
                approved: true
            });

            if (context.getters.company.id == companyId) {
                context.dispatch("fetchUsersForCurrentCompany");
            }
            return;
            // } catch (error) {
            //     throw error;
            // }
        },
        async disapproveUser(context, { companyId, userId }) {
            // try {
            await axios.post(`/company/approveuser`, {
                companyId,
                userId,
                approved: false
            });

            if (context.getters.company.id == companyId) {
                context.dispatch("fetchUsersForCurrentCompany");
            }
            return;
            // } catch (error) {
            //     throw error;
            // }
        },
        async fetchUsersForCurrentCompany(context) {
            // try {
            let response = await axios.get("/user/company");
            context.commit("users", response.data);
            return response.data;
            // } catch (error) {
            //     throw error;
            // }
        },
        async setMainuser(context, { companyId, userId }) {
            let response = await axios.post(`company/mainuser`, {
                companyId: companyId,
                userId: userId
            });

            if (context.getters.company.id == companyId) {
                await context.dispatch("fetchUsersForCurrentCompany");
            }

            let mainuser = response.data;
            context.commit("snackbar", {
                show: true,
                text: `Hovedbruker: ${mainuser.firstname} ${mainuser.lastname}`,
                color: "success"
            });
        },
        async getMainuser(context, { companyId }) {
            let response = await axios.get(`/company/mainuser/${companyId}`);
            return response.data;
        },

        // COMPANY
        async selectCompany(context, company) {
            await context.dispatch("updateToken", company.id);
            context.commit("company", company);
        },
        async fetchCompanies(context, { include } = { include: "" }) {
            let response = await axios.get("/company", { params: { include } });
            let companies = response.data;
            context.commit("companies", companies);
            return companies
        },

        // REPORT
        async sendReport(context, { description, applicationId, account, amount, files }) {
            let formData = new FormData();
            let fileCounter = 0;
            files.forEach(f => {
                formData.append(fileCounter.toString(), f);
                fileCounter++;
            });

            let reportDTO = {
                description: description,
                application_id: applicationId,
                contents: []
            };

            if (amount && amount) {
                reportDTO.account = account;
                reportDTO.amount = amount;
            }

            formData.append("report", JSON.stringify(reportDTO));

            // try {
            await axios.post("/report/upload",
                formData, {
                headers: {
                    "Content-Type": "multipart/form-data"
                }
            });

            return;
            // } catch (error) {
            //     throw error;
            // }

        }
    }
})
